/**
 * External dependencies
 */
import { omit } from 'lodash';
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import { START_EDITING_LOCATION_GROUP } from 'state/action-types';

import { createReducer } from 'state/utils';

export const locationGroupId = createReducer(null, {
    [START_EDITING_LOCATION_GROUP]: (state, { payload }) => payload.locationGroupId,
});

export default combineReducers({
    locationGroupId,
});
